module.exports = __webpack_public_path__ + "static/media/TransportGreyLogo.cd7eddd0.svg";